import sendGAEvent from './sendGAEvent'

const currentUrl = typeof window !== 'undefined' && window?.location?.href

export const BREADCRUMB = {
  LINK: 'breadcrumb__link',
}

export const PACKAGE_CARD = {
  handleClick: (packageName, requestId) => {
    sendGAEvent('package_card_clicks.sgl', {
      package_name: packageName,
      page_url: currentUrl,
      requestId,
    })
  },
}

export const FOOTER = {
  LINKS: {
    handleClick: (destination, linkText, requestId) => {
      sendGAEvent('footer_clicks.sgl', {
        current_url: currentUrl,
        destination,
        link_text: linkText,
        requestId,
      })
    },
  },
}

export const LINK_BUTTON = {
  handleClick: (text, link, requestId) => {
    sendGAEvent('cta_button_clicks.sgl', {
      button_text: text,
      href: link,
      current_url: currentUrl,
      requestId,
    })
  },
}

export const HEADER = {
  LOGO: {
    NAME: 'logo_clicks_to_home.sgl',
  },
  LINKS: {
    PHONE_LINK: 'header__phone-link.sgl',
    LEFT_PHONE_LINK: 'header__left-phone-link.sgl',
    handleClick: (text, link, requestId) => {
      sendGAEvent('header-nav-clicks.sgl', {
        link_text: text,
        destination: link,
        page_url: currentUrl,
        requestId,
      })
    },
  },
}

export const FORM = {
  handleClick: (values, requestId) => {
    sendGAEvent('long-form_submissions.sgl', {
      ...values,
      address: values?.address?.value,
      current_url: typeof window !== 'undefined' && window?.location?.href,
      requestId,
    })
  },
  AVAILABILITY: {
    handleClick: (zipcode, submitButtonText, requestId) => {
      sendGAEvent('zip-form_submissons.sgl', {
        zipcode,
        submit_button_text: submitButtonText,
        current_url: typeof window !== 'undefined' && window?.location?.href,
        requestId,
      })
    },
    SUCCESS: {
      handleClick: (zipcode, submitButtonText, requestId) => {
        sendGAEvent('zip-form_success.sgl', {
          zipcode,
          submit_button_text: submitButtonText,
          current_url: typeof window !== 'undefined' && window?.location?.href,
          requestId,
        })
      },
    },
    FAILED: {
      handleClick: (zipcode, submitButtonText, requestId) => {
        sendGAEvent('zip-form_failure.sgl', {
          zipcode,
          submit_button_text: submitButtonText,
          current_url: typeof window !== 'undefined' && window?.location?.href,
          requestId,
        })
      },
    },
  },
}

export const ACCORDION = {
  handleClick: (question, requestId) => {
    sendGAEvent('popular_faqs.sgl', {
      question,
      page_url: currentUrl,
      requestId,
    })
  },
}

export const MODAL = {
  NAME: 'change_location_modal.sgl',
}

export const ANCHOR = {
  NAME: 'destination_urls.sgl',
}

export const CTABAR = {
  NAME: 'sticky-cta-bar__phone',
}
